import { render, staticRenderFns } from "./RecommendationMapView.vue?vue&type=template&id=0734e7d4&"
import script from "./RecommendationMapView.vue?vue&type=script&lang=js&"
export * from "./RecommendationMapView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports